import { Button } from "@/components/ui/button";
import {
  Action,
  ControlType,
} from "@/context/AnalyticsProvider/AnalyticsProvider";
import { GamePageSection } from "@/context/AnalyticsProvider/gamePage";
import type { GPOnboardingStepProps } from "./utils";

export const FinalReward = ({ onNext, track }: GPOnboardingStepProps) => {
  const handleClick = () => {
    track({
      action: Action.PRESSED,
      extras: {
        control: "back-to-game",
        controlLabel: "Back to 8 Ball",
        controlType: ControlType.BUTTON,
        section: GamePageSection.ONBOARDING_MODAL,
      },
    });

    onNext();
  };

  return (
    <div className="flex-grow flex flex-col items-center justify-between gap-y-10">
      {/* Title */}
      <div>
        <h2 className="text-[clamp(1.25rem,6.25vw,1.875rem)] font-bold leading-[clamp(1.5rem,6.25vw,2.25rem)] text-center">
          Reward upgraded to
          <br />
          Gold tier
        </h2>
      </div>

      {/* Button */}
      <Button
        size="lg"
        className="h-12 px-6 rounded-[26px] text-lg font-medium shadow-[0px_1px_3px_0px_rgba(0,0,0,0.16),0px_1px_3px_0px_rgba(0,0,0,0.32)]"
        onClick={handleClick}
      >
        Back to 8 Ball
      </Button>
    </div>
  );
};
